import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Toast } from 'bootstrap';
import { lead_insert, getLeadConfig, getLeads } from "../../../api/lead";
import "./lead.css"

const AddLead = () => {
  const toastRef = useRef(null);
  const navigate = useNavigate();
  const [configuration, setConfiguration] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    source: '',
    lead_type: '',
    parent_name: '',
    studentClass: '',
    school: '',
    course: '',
    phone: '',
    city: '',
    country: '',
    message: '',
    assignToSelf: false,
  });

  const fetchConfig = async () => {
    const types = "lead_types,lead_sources,city,country,lead_status,priority";
    const configRes = await getLeadConfig(types);
    if (configRes.status) {
      setConfiguration(configRes.data);
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      name, email, source, lead_type, parent_name,
      studentClass, course, phone, message, city, country, school
    } = formData;

    if (!name || !email || !studentClass || !course || !phone || !message || !source || !lead_type || !parent_name || !city || !country || !school) {
      alert('Please fill in all fields before submitting.');
      return;
    }

    const data = {
      ...formData,
      stage: 'lead_panel',
      source: parseInt(source),
      lead_type_id: 1
    };

    const response = await lead_insert(data);
    if (response.status === true && toastRef.current) {
      const toast = new Toast(toastRef.current);
      toast.show();
      setFormData({
        name: '',
        email: '',
        source: '',
        lead_type: '',
        parent_name: '',
        studentClass: '',
        school: '',
        course: '',
        phone: '',
        city: '',
        country: '',
        message: '',
        assignToSelf: false,
      });
    }
  };

  const handleBackClick = () => {
    navigate("/home/lead-list");
    };

  return (
    <div className="container mt-5 addLead px-10">
        
      <h2 className="mb-4"><button className="btn btn-secondary mr-2" onClick={handleBackClick}>
                            ← Back
                        </button>Add New Lead</h2>
      <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1065 }}>
        <div
          ref={toastRef}
          className="toast align-items-center text-bg-success border-0"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="d-flex">
            <div className="toast-body">Lead Created Successfully!</div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              data-bs-dismiss="toast"
              aria-label="Close"
            ></button>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">Source</label>
            <select
              className="form-select"
              name="source"
              value={formData.source}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              {configuration?.lead_sources?.map((src) => (
                <option key={src.id} value={src.id}>{src.name}</option>
              ))}
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">Lead Type</label>
            <select
              className="form-select"
              name="lead_type"
              value={formData.lead_type}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              {configuration?.lead_types?.map((type) => (
                <option key={type.id} value={type.id}>{type.name}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Student Name</label>
          <input
            type="text"
            className="form-control"
            name="name"
            placeholder="Student Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Parent Name</label>
          <input
            type="text"
            className="form-control"
            name="parent_name"
            placeholder="Parent Name"
            value={formData.parent_name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Email</label>
          <input
            type="email"
            className="form-control"
            name="email"
            placeholder="E-mail ID"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Phone No.</label>
          <input
            type="tel"
            className="form-control"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">School Name</label>
          <input
            type="text"
            className="form-control"
            name="school"
            placeholder="School Name"
            value={formData.school}
            onChange={handleChange}
            required
          />
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">Class</label>
            <select
              className="form-select"
              name="studentClass"
              value={formData.studentClass}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              {[6, 7, 8, 9, 10, 11, 12].map(c => (
                <option key={c} value={`${c}th`}>{c}th</option>
              ))}
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">Course</label>
            <select
              className="form-select"
              name="course"
              value={formData.course}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              {['SCHOOL', 'JEE', 'NEET', 'Boards', 'SAT'].map((course) => (
                <option key={course} value={course}>{course}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">City</label>
            <select
              className="form-select"
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              {configuration?.city?.map((city) => (
                <option key={city.id} value={city.id}>{city.name}</option>
              ))}
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">Country</label>
            <select
              className="form-select"
              name="country"
              value={formData.country}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              {configuration?.country?.map((country) => (
                <option key={country.id} value={country.id}>{country.name}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Remarks</label>
          <textarea
            className="form-control"
            rows="3"
            name="message"
            placeholder="Type your remarks"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        <div className="mb-3 form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="assignToSelf"
            name="assignToSelf"
            checked={formData.assignToSelf}
            onChange={handleChange}
          />
          <label className="form-check-label fw-semibold" htmlFor="assignToSelf">
            Assign to Self
          </label>
        </div>

        <button type="submit" className="primary-button btn btn-primary w-100 rounded-pill">
          Submit
        </button>
      </form>
    </div>
  );
};

export default AddLead;
